module.exports = __webpack_public_path__ + "static/media/damir-bosnjak.a6f24e7d.jpg";